import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import '../../core/feedback/components/styles.css'

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { StylesProvider, ThemeProvider as JssThemeProvider } from '@mui/styles'

import { ReduxProvider } from '../../core/redux'
import { I18NProvider } from '../../core/i18n'
import { AjaxProvider } from '../../core/ajax'
import { Modal as ModalProvider } from '../../ui/modal'
import { BootstrapRouter } from '../routers/bootstrap.router'
import OnCrash from '../onCrash/onCrash.component'
import { OnServerDown } from '../onServerDown/onServerDown.component'
import { theme } from '../../core/theme/constants/theme'

export const BootstrapComponent = () => {
  return (
    <ReduxProvider>
      <StylesProvider>
        <JssThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
            <I18NProvider>
              <AjaxProvider>
                <OnServerDown>
                  <OnCrash>
                    <BrowserRouter>
                      <ModalProvider>
                        <BootstrapRouter />
                      </ModalProvider>
                    </BrowserRouter>
                  </OnCrash>
                </OnServerDown>
              </AjaxProvider>
              <ToastContainer theme="colored" limit={1} autoClose={10000} />
            </I18NProvider>
          </MuiThemeProvider>
        </JssThemeProvider>
      </StylesProvider>
    </ReduxProvider>
  )
}
